import SectionFilms from './SectionFilms';

export default SectionFilms;
export * from './SectionFilms';
